import type { ReapproAlgorithm, ReaproPeriode } from '@gozoki/api-types'
import { useForm } from 'react-hook-form'

export interface ReaproCategoryStoreParams {
  algorithm: ReapproAlgorithm
  periode: ReaproPeriode
  coefSecu: number
  coefWeekend: number
  coverageRate: number | null
}

export const DEFAULT_REAPPRO_STORE_CATEGORY_PARAMS: ReaproCategoryStoreParams = {
  algorithm: 'VMAX',
  periode: '5J',
  coefSecu: 1,
  coefWeekend: 1,
  coverageRate: null,
}

export interface ReapproAlgorithmsFormValues {
  params: Record<string, ReaproCategoryStoreParams>
}

export const useReapproAlgorithmMatrixForm = () =>
  useForm<ReapproAlgorithmsFormValues>({
    defaultValues: { params: {} },
  })
